<template>
  <SoAlert type="info" title="Raise a Siteworks task">
    <p class="mt-3">{{ firstParagraph }}</p>
    <p class="mt-4">{{ secondParagraph }}</p>
    <p class="mt-4 mb-1">
      Raise a
      <b>
        Siteworks - CCA (Medium Pressure/Three Phase/Meter Move/Supply
        Upgrade/Meter Removal/Capping)
      </b>
      task on this case. Work with the customer to fill in all the required
      fields on the task, and advise the customer that they will need to provide
      a photo of the meter and its surroundings.
    </p>
  </SoAlert>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoAlert from "@/components/SoAlert.vue"

  export default defineComponent({
    components: {
      SoAlert,
    },
    props: {
      hasComplexMeterSetup: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      firstParagraph(): string {
        if (this.hasComplexMeterSetup) {
          return "Please advise the customer that because their metering setup is complex, a specialist team will need to book their smart meter install."
        }
        return "Please advise the customer that there will be a charge associated with this job."
      },
      secondParagraph(): string {
        if (this.hasComplexMeterSetup) {
          return "Advise the customer that our Siteworks team will aim to reach out to them within 2 working days."
        }
        return "If the customer agrees, advise them that our Siteworks team will aim to reach out to them within 2 working days to provide a quote."
      },
    },
  })
</script>
